import { useContext, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useAuth } from "react-oidc-context";
import { Link, Navigate, useParams } from "react-router-dom";

import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Preloader } from "../../components";
import { LAST_ROUTE, routes } from "../../constants";
import { UserDataContext } from "../../contexts/userDataContext";
import { formatUserNameWithEmailString } from "../../utils";

export const RegisterSubToOrg = () => {
	let { invitationId, email: emailEncoded } = useParams<{
		invitationId: string;
		email: string;
	}>();
	const [isRedirect, setIsRedirect] = useState(false);
	const { signoutRedirect, user } = useAuth();
	const [isPreloader, setIsPreloader] = useState(false);

	const { userProfile } = useContext(UserDataContext);

	const handleUserLogin = () => setIsRedirect(true);

	if (isRedirect) {
		return (
			<Navigate
				to={`${routes.registerExistingUserSub.path}/${emailEncoded}/${invitationId}`}
				replace
			/>
		);
	}

	return (
		<main>
			<section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
				<Preloader show={isPreloader} />
				<Container>
					<Row className="justify-content-center">
						<div className="text-center">
							<Card.Link
								as={Link}
								to={routes.dashboardOverview.path}
								className="text-gray-700"
							>
								<FontAwesomeIcon
									icon={faAngleLeft}
									className="me-2"
								/>
								To dashboard
							</Card.Link>
						</div>
						<Col
							xs={12}
							lg={6}
							className="d-flex justify-content-center"
						>
							<div
								style={{ position: "relative" }}
								className="mb-4 mb-lg-0 bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500"
							>
								<div className="text-center text-md-center mb-4 mt-md-0">
									<h3 className="mb-0">
										{userProfile.email
											? `Continue as ${formatUserNameWithEmailString(
													userProfile
											  )}`
											: "Sign in with Austin Cloud to Register"}
									</h3>
								</div>
								<Button
									variant="primary"
									type="submit"
									className="w-100"
									onClick={handleUserLogin}
								>
									{userProfile.email ? "Continue" : "Sign in"}
								</Button>
								{userProfile.email ? (
									<Button
										variant="primary"
										type="submit"
										className="w-100 mt-2"
										onClick={() => {
											setIsPreloader(true);
											sessionStorage.setItem(
												LAST_ROUTE,
												window.location.pathname
											);

											signoutRedirect({
												id_token_hint: user?.id_token,
												state: user?.state,
											});
										}}
									>
										Logout
									</Button>
								) : null}
							</div>
						</Col>
					</Row>
				</Container>
			</section>
		</main>
	);
};
